// ** Third Party Components
import styled from "styled-components";

// #####################################################

export const StyledPicturesList = styled("div")`
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	grid-row-gap: var(--grid-gap);
	grid-column-gap: var(--grid-gap);
`;

// #####################################################
